import { render, staticRenderFns } from "./TableWlPrices.vue?vue&type=template&id=25ab4871"
import script from "./TableWlPrices.vue?vue&type=script&lang=js"
export * from "./TableWlPrices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports